import { render, staticRenderFns } from "./TagEntry.vue?vue&type=template&id=3cd84874&scoped=true&"
import script from "./TagEntry.vue?vue&type=script&lang=js&"
export * from "./TagEntry.vue?vue&type=script&lang=js&"
import style0 from "./TagEntry.vue?vue&type=style&index=0&id=3cd84874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd84874",
  null
  
)

export default component.exports